// port of state so that API doesn't need react (which green-state depends on)
export type IStateCallback<T> = (state?: T) => void;

export class State<T = any> {
    public state?: T;
    private subscriptions: Array<IStateCallback<T>> = [];

    constructor(initialState?: T ) {
        this.state = initialState;
    }

    setState = (newState: Partial<T>) => {
        this.state = { ...this.state, ...newState } as T;
        this.publish();
    }

    private publish = () => {
        this.subscriptions.forEach(sub => sub(this.state));
    }

    subscribe = (callback: IStateCallback<T>) => {
        this.subscriptions.push(callback);
        if (this.state) {
            callback(this.state);
        }

        return () => {
            remove(callback, this.subscriptions);
        };
    }

    dispose = () => {
        this.subscriptions = [];
        this.subscribe = () => {
            throw new Error('Cannot subscribe to a disposed State instance');
        };
    }
}

/**
 * @ignore
 */
function remove<T>(item: T, array: T[]) {
    const index = array.indexOf(item);
    if (index > -1) {
        array.splice(index, 1);
    }
}
